import { formatPhoneNumber } from 'lib/helpers/utility';

export const formatReceiptPhone = (phone) =>
  phone ? String(formatPhoneNumber(phone, { withCountryCode: true })) : '';

export const toReceiptPractice = (practice) =>
  practice && { ...practice, tax_id: null, phone: formatReceiptPhone(practice.phone) };
